import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const MyHrUserTwoFactorCardNotActived = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box>
      <Box display="flex" flexDirection="row">
        <Box width="50%">
          <Typography variant="body1">
            {t("MY_HR_TWO_FACTOR_AUTHENTICATION")}:
          </Typography>
        </Box>
        <Box width="50%">
          <Typography variant="body1" color={theme.palette.primary.main}>
            {t("MY_HR_INACTIVE")}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ marginTop: "-4px" }}>
        <Typography variant="caption" sx={{ color: theme.palette.owGray.main }}>
          {t("MY_HR_USER_NOT_REGISTERED_2FA")}
        </Typography>
      </Box>
    </Box>
  );
};

export default MyHrUserTwoFactorCardNotActived;
